import React from 'react';
import { node, object, } from 'prop-types';
import { contains } from 'ramda';

import { connect } from 'react-redux';
import * as PublicTypes from '../actions/public/types';

import Layout from '../components/Layout';
import ActionsPanel from '../components/ActionsPanel/ActionsPanel';
import PracticeDetails from '../components/Pages/Login/LandingPage/PracticeDetails/PracticeDetails';
import HeaderBranding from '../components/HeaderBar/HeaderBranding';

import s from '../components/Pages/Login/LandingPage/LandingPage.css';


const ResetLayout = ({ ...props }) => {
  const path = props.location.pathname;
  const logoUrl = props.preferences.logoUrl;
  const practiceDetailsLoadingState = loadingState => contains(PublicTypes.GET_PRACTICE_DETAILS, loadingState.requests);
  const isLoadingPracticeDetails = practiceDetailsLoadingState(props.loadingState);

  return (
    <Layout mobileColumn mobileReverse>
      <div className={s.contentContainer}>
        <HeaderBranding
          activeRoute={path}
          className={s.branding}
          logoUrl={logoUrl}
        />
        <section className={s.content}>
          <PracticeDetails
            isLoadingPracticeDetails={isLoadingPracticeDetails}
            preferences={props.preferences}
            practiceDetails={props.publicState}
          />
        </section>
      </div>
      <ActionsPanel className={s.actionsPanelContainer}>
        {props.children}
      </ActionsPanel>
    </Layout>
  );
};

ResetLayout.propTypes = {
  children: node,
  loadingState: object,
  location: object,
  publicState: object,
  preferences: object,
};

// The call to getPracticeDetails is made in the parent UnauthLayout and we map the props from here
const mapStateToProps = (state) => ({
  loadingState: state.loadingState,
  preferences: state.preferences,
  publicState: state.publicState,
});

export default connect(mapStateToProps)(ResetLayout);



// WEBPACK FOOTER //
// ./src/layouts/ResetLayout.js